<div class="card-container">
  <div class="card-container__inner">
    @for (card of cards; track $index) {
      <root-nav-card [card]="card" (cardClick)="handleCardClick(card)"> </root-nav-card>
    }
  </div>
</div>
